<script>
  export let id;
  $: console.log("this id:", id);
  if (!id) {
    id = "xx4I";
  }

  import { slide, fly } from "svelte/transition";

  //global Store
  import globalStore from "../stores/globalStore.js";
  import machines from "../stores/machines.js";
  import azucarOptions from "../stores/azucarOptions.js";
  //components
  import Loading from "../components/Loading.svelte";
  import Display from "../components/Display.svelte";
  import QRCode from "../components/QRCode/QRJS.svelte";
  import { link } from "svelte-routing";

  let producto = 0;
  let productoLabel = "";
  let showAzucar = false;
  let showOptionsMenu = false;
  let isPedidoMultiple = false;

  let azucar = 9;
  let azucarLabel = "";
  // let azucarLabels = [
  //   "Sin azúcar",
  //   "Con poca azúcar",
  //   "Con azúcar",
  //   "Con bastante azúcar",
  //   "Con mucha azúcar"
  // ];

  let productoSeleccionado = false;

  let showQRCode = false;

  $: machine = $machines.find(item => item.id === id);
  $: thisAzucarBtns = $azucarOptions[0];

  function createQR() {
    if (productoSeleccionado) {
      showQRCode = true;
      doPushState("qrcode");
    }
  }

  function handleAzucarClick(cod, label) {
    console.log("azucar:", azucar);
    azucarLabel = label;
    azucar = cod;
    setTimeout(() => {
      createQR();
    }, 400);
  }
  function doPushState(hash) {
    const state = { hash: hash },
      title = `${
        hash === "azucar"
          ? `Te apetece dulce`
          : hash === "qrcode"
          ? `Muestra este código a la máquina`
          : ``
      }`,
      path = `#${hash}`;
    history.pushState(state, title, path);
  }
  function handleClickedButton(cod, label) {
    console.log("handleClickedButton:");
    doPushState("azucar");
    producto = cod;
    productoLabel = label;
    productoSeleccionado = true;
    setTimeout(() => {
      showAzucar = true;
    }, 500);
  }

  window.addEventListener("popstate", event => {
    const state = event.state;
    if (state && state.hash && state.hash === "azucar") {
      showAzucar = true;
      showQRCode = false;
    } else {
      showAzucar = false;
      showQRCode = false;
    }
  });

  function handlePedidoMultipleClick() {
    isPedidoMultiple = true;
  }

  function handleShowOptionsMenu() {
    console.log("handleShowOptionsMenu EXECUTED:");
    console.log("showOptionsMenu:", showOptionsMenu);
    showOptionsMenu = !showOptionsMenu;
  }
  function handleHistoryBack() {
    window.history.back();
  }
  function resetSelections() {
    producto = 0;
    productoLabel = "";
    azucar = 9;
    azucarLabel = "";
    showAzucar = false;
    showQRCode = false;
    productoSeleccionado = false;
    history.pushState(
      "",
      document.title,
      window.location.pathname + window.location.search
    );
  }
</script>

<style>
  @keyframes pulse {
    from {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
    to {
      transform: scale(1);
    }
  }

  .led {
    margin: 0 auto;
    width: 0.5em;
    height: 0.5em;
    border-radius: 50%;
  }
  .led-red {
    background-color: #a00;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #441313 0 -1px 9px,
      rgba(255, 0, 0, 0.5) 0 2px 0;
    animation: 0.5s;
  }
  .led-red.led-red-on {
    background-color: #f00;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #ff0000 0 -1px 9px,
      rgba(255, 0, 0, 0.5) 0 0px 6px 3px;
  }

  .led-blue {
    background-color: #0fa4e4;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px, inset #006 0 -1px 9px,
      #053378 0 2px 14px;
  }
  .led-blue.led-blue-on {
    background-color: #24e0ff;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 7px 1px,
      inset rgb(0 0 102 / 0.5) 0 -1px 9px, #3f8cff 0 2px 14px;
  }
  .wrapper {
    background: #0e1743;
    border-radius: 10px 10px 0 0;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }
  .wrapper > header {
    display: flex;
    position: relative;
    z-index: 10;
  }
  .wrapper > header img {
    max-width: 200px;
    margin: auto;
  }
  .wrapper > header nav {
    margin-left: auto;
  }
  .wrapper > header nav button {
    margin: 0px;
    border-radius: 0 10px 0 0;
    min-height: 52px;
    width: 52px;
    cursor: pointer;
    border: 1px solid white;
    border-top: 0;
    box-shadow: inset 0 0 10px #000000;
    background: #333;
    color: #fff;
    font-size: 2em;
    padding: 0;
  }
  .wrapper > header nav button.pressed {
    border-bottom: 0;
    box-shadow: none;
    background: #000;
    z-index: 2;
    position: relative;
  }
  .wrapper > header nav button.pressed svg {
    transform: rotate(-90deg);
  }
  .wrapper > header nav ul {
    position: absolute;
    background: red;
    left: 0;
    margin: 0;
    width: 100%;
    list-style-type: none;

    background-image: linear-gradient(to top, #6a667d 0%, #000000 100%);

    /* min-height: 50vh; */
    border-radius: 0 0 10px 10px;
    z-index: 1;
    border: 1px solid white;
    /* border-top: 0; */
    margin-top: -1px;
    box-shadow: inset 0 0 10px #000000;
    padding: 40px;
  }
  .wrapper > header nav ul li a {
    display: block;
    line-height: 3em;
    color: white;
  }
  .svg-inline--fa {
    display: inline-block;
    font-size: inherit;
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
    transition: transform 0.4s;
  }
  .machine-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-image: linear-gradient(to bottom, #0e184a 0%, #284eb9 100%),
      url(/images/cafe_w600_2.jpg);
    background-blend-mode: multiply;
    background-size: contain;
    max-width: 100vw;
  }
  .machine-container header {
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    height: 178px;
    overflow-x: hidden;
  }
  /* .azucar-selector-wrapper {
    display: flex;
    justify-content: center;
  }
  .azucar-selector-wrapper span {
    padding: 5px 20px;
    font-size: 1.3em;
  }
  .btn.azucarMenos {
    border-radius: 10px 0 0 10px;
    font-size: 2.3em;
  }
  .azucarTitle {
    border-radius: 0;
    color: white;
    display: flex;
    align-items: center;
    flex-flow: row;
    border: 1px solid #928dab;
    box-shadow: inset 0 0 10px #000000;
    cursor: pointer;
    font-size: 5vw;
  }
  .btn.azucarMas {
    border-radius: 0 10px 10px 0;
    font-size: 2.3em;
  } 
  .seleccionCompletadaBtn {
    width: 50%;
    margin: 0 auto 0.5em;
    text-align: center;
    background-image: linear-gradient(
      to top,
      #2d2b35 0%,
      #000000 50%,
      #575467 100%
    );
    padding: 16px;
    border-radius: 5px;
    border: 2px solid #ffffff;
    color: #fff;
    opacity: 0;
    transition: 0.5s;
  }
  .opaco {
    opacity: 1;
  }
   .semicircle {
    border-radius: 50% 50% 0 0;
    border: 3.3vw solid rgb(155, 198, 238);
    width: 10vw;
    margin: 0 auto;
    height: 10vw;
    border-bottom: 0;
  } */
  .botonera {
    display: grid;
    column-gap: 15px;
    row-gap: 5px;
    min-height: calc(100vh - 230px);
    position: relative;
    padding: 5px 5px 65px;
  }
  .botonera .btn {
    /* min-height: 100px; */
  }

  .btn {
    /* background: rgb(55, 55, 55); */
    color: white;
    background-image: linear-gradient(to left, #575467 0%, #000000 100%);
    display: flex;
    align-items: center;
    flex-flow: row;
    border: 1px solid #928dab;
    box-shadow: inset 0 0 10px #000000;
    cursor: pointer;
    border-radius: 10px;
    transition: 0.5s;
    font-size: 5vw;
  }
  .btn:hover {
    background-position: right center; /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
  }

  .btn span {
    flex-grow: 1;
    padding: 0 0 0 10px;
  }
  .btn em {
    height: 100%;
    background: #fff;
    width: 3.3vw;
    display: flex;
    align-items: center;
  }
  .alignRight {
    background-image: linear-gradient(to right, #575467 0%, #000000 100%);

    justify-content: flex-end;
    flex-flow: row-reverse;
    text-align: right;
  }
  .alignRight span {
    padding: 0 10px 0 0;
  }
  .showCode-info {
    color: white;
    text-align: center;
    position: absolute;
    top: 180px;
    width: 80vw;
    left: 10vw;
    font-family: Ubuntu;
    letter-spacing: 1px;
    animation: pulse 2s infinite;
  }
  .final-step {
    min-height: calc(100vh - 230px);
    background: white;
  }
  .final-step .btn {
    padding: 15px;
    max-width: 210px;
    margin: auto;
    text-align: center;
    display: block;
  }
  @media screen and (orientation: landscape) {
    .wrapper.no-landscape {
      transform: rotate(-90deg);
      transform-origin: left top;
      height: 100vw;
      overflow-x: hidden;
      position: absolute;
      top: 100%;
      left: 0;
    }
  }
</style>

<svelte:head>
  <title>{!machine ? 'Panel máquina vending' : machine.title}</title>
</svelte:head>

<div class="wrapper" class:no-landscape={showQRCode}>
  <header>
    <img src="/images/logo.svg" alt="" />
    <nav>
      <button
        class:pressed={showOptionsMenu}
        on:click={() => {
          handleShowOptionsMenu();
        }}>
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fal"
          data-icon="ellipsis-v-alt"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 192 512"
          class="svg-inline--fa fa-ellipsis-v-alt fa-w-6 fa-3x">
          <path
            fill="currentColor"
            d="M96 152c39.8 0 72-32.2 72-72S135.8 8 96 8 24 40.2 24 80s32.2 72
            72 72zm0-112c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40
            17.9-40 40-40zm0 144c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2
            72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40 40-40 40
            17.9 40 40-17.9 40-40 40zm0 64c-39.8 0-72 32.2-72 72s32.2 72 72 72
            72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40s17.9-40
            40-40 40 17.9 40 40-17.9 40-40 40z"
            class="" />
        </svg>
      </button>
      {#if showOptionsMenu}
        <ul transition:slide>
          <li>
            <a href="#pedidoMultiple" on:click={handlePedidoMultipleClick()}>
              Pedido múltiple
            </a>
          </li>
          <li>
            <a href="#pedidoMultiple" on:click={handlePedidoMultipleClick()}>
              Quiénes somos
            </a>
          </li>
          <li>
            <a href="#ayuda" on:click={handlePedidoMultipleClick()}>Ayuda</a>
          </li>
        </ul>
      {/if}
    </nav>
  </header>
  {#if !machine}
    <Loading />
  {/if}
  <!-- singlemachine container -->
  <article class="machine-container">
    <header>
      <Display {productoSeleccionado} {productoLabel} {azucarLabel} {azucar} />
      {#if showQRCode}
        <p class="showCode-info">Muestra el código a la máquina</p>
      {/if}
      <!-- <div class="azucar-selector-wrapper">
          <span class="btn azucarMenos">-</span>
          <span class="azucarTitle">Azúcar</span>
          <span class="btn azucarMas">+</span>

        </div>
        <div
          class:opaco={productoSeleccionado}
          class="seleccionCompletadaBtn"
          on:click={createQR}>
          Ya he seleccionado
        </div> -->
      <!-- <div class="semicircle">&nbsp;</div> -->
    </header>
    {#if !showQRCode}
      {#if !showAzucar}
        <section
          in:fly={{ x: 200, duration: 400, delay: 400 }}
          out:fly={{ x: -200, duration: 400 }}
          class="botonera"
          style="grid-template-columns: repeat({machine.btns.numColumnas}, 1fr);
          grid-template-rows: repeat({machine.btns.numFilas}, 1fr);">
          {#each machine.btns.items as item}
            <div
              class="btn"
              style="grid-column: {item.pos.c}; grid-row: {item.pos.f};"
              on:click={handleClickedButton(item.cod_producto, item.leyenda)}
              class:alignRight={item.pos.c % 2 === 0}>
              <span>{item.leyenda}</span>
              <em>
                <div
                  class="led led-red"
                  class:led-red-on={producto === item.cod_producto} />
              </em>
            </div>
          {/each}
        </section>
      {:else}
        <section
          in:fly={{ x: 200, duration: 400, delay: 400 }}
          out:fly={{ x: -200, duration: 400 }}
          class="botonera botonera-azucar"
          style="grid-template-columns: repeat({thisAzucarBtns.btns.numColumnas},
          1fr); grid-template-rows: repeat({thisAzucarBtns.btns.numFilas}, 1fr);">
          {#each thisAzucarBtns.btns.items as item}
            <div
              class="btn"
              style="grid-column: {item.pos.c}; grid-row: {item.pos.f};"
              on:click={() => {
                item.cod_producto === 999 ? handleHistoryBack() : handleAzucarClick(item.cod_producto, item.leyenda);
              }}
              class:alignRight={item.pos.c % 2 === 0}>
              <span>{item.leyenda}</span>
              <em>
                {#if item.cod_producto !== 999}
                  <div
                    class="led led-blue"
                    class:led-blue-on={azucar === item.cod_producto} />
                {/if}
              </em>
            </div>
          {/each}
        </section>
      {/if}
    {:else}
      <div
        class="final-step"
        in:fly={{ x: 200, duration: 400, delay: 400 }}
        out:fly={{ x: -200, duration: 400 }}>
        <QRCode codeValue="{producto}.{azucar}" squareSize="200" />
        <p>
          <span class="btn" on:click={() => resetSelections()}>
            Volver a empezar
          </span>
        </p>
      </div>
    {/if}
  </article>
</div>
